import type { FaireThemeEntity } from "../../entity_types/theme";

export const island_snack_souvenirs: FaireThemeEntity = {
  token: "island-snack-souvenirs",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Island Snack Souvenirs",
  description: "Perfect for tour add-ons and checkout impulse buys",
  bgColor: "#F5D6D6",
  tileBgColor: "#826e25",
  productTokens: [
    "p_snxwcsuejk",
    "p_ma8yyyesjy",
    "p_9b7xyqnrs8",
    "p_cusr8qy8ch",
    "p_hn7zh5tvd9",
    "p_4xe6ydayss",
    "p_y46bh2p7x4",
    "p_jmsk4bzvwh",
    "p_8a86cnfc99",
    "p_c3f7g32qdr",
    "p_kaf4sgetrv",
    "p_cyqdnqvaga",
    "p_yqkmp8hexz",
    "p_sddafsbt2n",
    "p_bmhrauddug",
    "p_ce73zbd4hx",
    "p_zw7jcm4vca",
    "p_a8usq79s3n",
    "p_h2mjjtdke4",
    "p_qk9k6an32v",
    "p_pb2q2a7qg5",
    "p_c7238w82uk",
    "p_43sdpnx5eu",
    "p_jevj6sycyt",
    "p_px934ush8b",
    "p_e3cp6cz5rm",
    "p_92tfmnb4kg",
    "p_cbkrehyr8s",
    "p_wj6eqc8rrn",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
